import { render } from "./CreationOptions.vue?vue&type=template&id=724f4796&scoped=true"
import script from "./CreationOptions.vue?vue&type=script&lang=js"
export * from "./CreationOptions.vue?vue&type=script&lang=js"

import "./CreationOptions.vue?vue&type=style&index=0&id=724f4796&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-724f4796"]])

export default __exports__